<template>
  <v-dialog v-model="showLocalDialog" width="450">
    <v-card class="sigfloCard" width="450">
      <v-card-title> Change Password </v-card-title>
      <v-card-text>
        <v-form ref="changePasswordForm" submit-prevent>
          <v-text-field
            autofocus
            label="Old Password"
            outlined
            filled
            required
            v-model="oldPassword"
            :rules="passwordRule"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            @click:append="showPassword = !showPassword"
          ></v-text-field>
          <v-text-field
            label="New Password"
            outlined
            filled
            required
            v-model="password"
            :rules="passwordRule"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            @click:append="showPassword = !showPassword"
          ></v-text-field>
          <v-text-field
            label="Confirm New Password"
            outlined
            filled
            required
            :rules="[passwordMatchRule]"
            v-model="password2"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            @click:append="showPassword = !showPassword"
          ></v-text-field>
          <v-btn rounded class="sigfloButton400 text-capitalize" color="primary" @click="changePassword">save</v-btn>
          <div class="mt-2 red--text">{{ error }}</div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        showPassword: false,
        oldPassword: '',
        password: '',
        password2: '',
        showLocalDialog: this.showDialog,
        error: null
      };
    },
    computed: {
      ...mapState(['app'])
    },
    watch: {
      showDialog(val) {
        this.showLocalDialog = val;
      },
      showLocalDialog(val) {
        this.$emit('close', val);
      }
    },
    methods: {
      /**
       * Handles the change password functionality.
       * Validates the form, checks if the passwords match, and dispatches an action to change the password.
       * If the password change is successful, displays a success message and closes the dialog.
       * If there is an error, displays the error message.
       */
      changePassword() {
        if (this.$refs.changePasswordForm.validate()) {
          this.$store
            .dispatch('app/changePassword', {
              email: this.app.user.email,
              password: this.oldPassword,
              newPassword: this.password
            })
            .then((response) => {
              if (response.status === 200) {
                this.error = null;
                this.$store.dispatch('app/showSuccess', 'Password changed successfully');
                this.showLocalDialog = false;
              } else {
                this.error = response;
              }
            });
        }
      }
    }
  };
</script>
